// Get the API key from the environment injected by import-meta-env
const googleMapsApiKey = import.meta.env.GOOGLE_MAPS_API_KEY;
if (!googleMapsApiKey) {
  // Log an error if the key is missing. The map components will likely fail later.
  console.error("Google Maps API Key (GOOGLE_MAPS_API_KEY) was not found in environment variables. Maps may not load.");
} else {
  // Define the global callback function that Google Maps API will call when ready
  // @angular/google-maps typically detects the API load implicitly,
  // but defining the callback is standard practice and good for debugging.
  window.initMap = () => {
    // You could potentially emit an event here if other parts of your app
    // need to know the API is ready outside of Angular components.
  };
  // Create the script element
  const script = document.createElement('script');
  script.async = true; // Load asynchronously
  script.defer = true; // Defer execution until HTML parsing is complete
  // Construct the URL including the API key and the callback function name
  // Optionally add libraries like 'places', 'marker' if needed: &libraries=places,marker
  script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&callback=initMap`;
  // Optional: Add error handling for the script load itself
  script.onerror = () => {
    console.error("Failed to load the Google Maps JavaScript API script. Check API key, network connection, and script URL.");
    // Clean up the callback if the script fails to load
    if (window.initMap) {
      delete window.initMap;
    }
  };
  // Append the script to the document's head
  document.head.appendChild(script);
  //   console.log("Google Maps API script tag appended to head.");
}
export {};